import { useState } from "react";
import { MdLiveTv, MdOutlineScoreboard } from "react-icons/md";
export const sportsMapping = {
    4: "Cricket",
    1: "Soccer",
    2: "Tennis"
}
function MatchDetailsBanner({ sportId, eventId, eventName }) {
    const [liveTv, setLiveTv] = useState(false);
    const [liveScore, setLiveScore] = useState(true);

    return (
        <>
            <div className="w-full">
                <div className="w-full flex flex-row justify-between items-center min-h-9 py-1 px-3" style={{ background: "linear-gradient(-180deg, #2E4B5E 0%, #243A48 82%)" }}>
                    <div
                        role="button"
                        onClick={() => { setLiveScore(prev=>!prev); setLiveTv(false); }}
                    >
                        <MdOutlineScoreboard color={liveScore ? "green" : "red"} size={25} />
                    </div>
                    <p role="button" className="text-white font-semibold line-clamp-1 text-center text-xs" style={{ width: "calc(100% - 30px - 25px)" }}>{`${sportsMapping[sportId]} > ${eventName}`}</p>
                    <div role="button"
                        onClick={() => { setLiveScore(false); setLiveTv(prev=>!prev); }}

                    >
                        <MdLiveTv color={liveTv ? "green" : "red"} size={25} />
                    </div>
                </div>
                {<div style={{ overflow: "auto", backgroundColor: "#141435" }}>
                    <iframe
                        className={`scrollbar-hide ${liveScore ? "aspect-video" : "hidden"}`}
                        src={`https://asianexchange.club/score?sport_id=${sportId}&event_id=${eventId}`}
                        allow="autoplay; picture-in-picture"
                        width="100%"
                        height={!liveScore ? "1px" : "124px"}
                        loading="lazy"
                        style={{ backgroundColor: "#141435" }}
                    />
                </div>}

                {/* {
                    <div id="full-market-live-tv" className="overflow-y-hidden w-full flex flex-row justify-center items-center bg-[#141435]">

                        <div className={`overflow-y-hidden mt-0 max-w-[100vw] flex flex-row justify-center ${liveTv ? "w-full max-w-[500px]" : ""}`} style={{ backgroundColor: "#141435" }}>
                            <iframe
                                className={`scrollbar-hide ${liveTv ? "" : "hidden"} overflow-y-hidden`}
                                src={`https://royalexch.online/tv?sportId=${sportId}&eventId=${eventId}&muted`}
                                allow="autoplay; picture-in-picture"
                                width="100%"
                                height={!liveTv ? "1px" : "auto"}
                                loading="lazy"
                                style={{ backgroundColor: "#141435" }}
                                allowFullScreen
                            />

                        </div>
                    </div>
                } */}
                <div
                    id="full-market-live-tv"
                    className="w-full bg-[#141435] flex justify-center items-center overflow-hidden"
                >
                    <div className={`relative ${liveTv ? "w-full max-w-[720px]" : ""} aspect-video`}>
                        <iframe
                            src={`https://royalexch.online/tv?sportId=${sportId}&eventId=${eventId}&muted`}
                            allow="autoplay; picture-in-picture"
                            className={`absolute top-0 left-0 w-full ${liveTv ? "h-full" : "1px"} border-0`}
                            loading="lazy"
                            allowFullScreen
                        />
                    </div>
                </div>

            </div>
            {/* <div className={`w-full`} style={{ // margin-gutter
                height: `calc(36px + ${liveScore ? "124px" : (liveTv ? "280px" : "0px")})`
            }} /> */}
        </>
    )
}

export default MatchDetailsBanner
